import { combineReducers } from 'redux';
import system from './portal/system';
import institutions from './portal/institutions';
import services from './portal/services';
import adminDocuments from './admin/documents';
import adminInstitution from './admin/institutions';
import adminPersonal from './admin/personal';
import adminService from './admin/services';
import doctors from './admin/doctors';

import adminMails from './admin/mailing';
import admin from './admin/admin';
import users from './admin/users';
import auth from './auth';
import operator from './operator/operator';
import records from './portal/records';
import news from './portal/news';
import prozorro from './portal/prozorro';
import { reducer as formReducer } from 'redux-form'


const reducer = combineReducers({
  system,
  institutions,
  services,
  doctors, 
  adminDocuments,
  adminInstitution,
  adminPersonal,
  adminService,
  adminMails,
  admin,
  users,
  auth,
  operator,
  records,
  news,
  prozorro,
  form : formReducer
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js